import React from 'react';
import styled from 'styled-components';

import { get, system } from '@styled-system/core';
import theme from 'theme';

const getSpacer = (n: any, scale: any) => get(scale, n, n);

const config = {
  width: {
    property: 'width',
    scale: 'space',
    transform: getSpacer,
    defaultScale: theme.space
  },
  height: {
    property: 'height',
    scale: 'space',
    transform: getSpacer,
    defaultScale: theme.space
  }
};

const spacer = system(config);

type StyledSpacerProps = {
  width?: number;
  height?: number;
};

type SpacerProps = {
  size?: number;
  horizontal?: boolean;
  hidden?: boolean;
};

const StyledSpacer = styled.div<StyledSpacerProps>(spacer);

const Spacer: React.FC<SpacerProps> = ({
  size = 3,
  horizontal = false,
  hidden = false
}) => {
  if (hidden) return null;

  const props = horizontal ? { width: size } : { height: size };

  return <StyledSpacer {...props} />;
};

export default Spacer;
